import { composeIO } from 'react-compose-io'
import { popoverFiltroParceiroIO } from './PopoverFiltroParceiro.IO'
import { PopoverFiltroParceiroView } from './PopoverFiltroParceiro.View'

export const PopoverFiltroParceiro = composeIO(PopoverFiltroParceiroView, popoverFiltroParceiroIO)
